declare const __BUILD_HASH__: string;
declare const __BUILD_TIME__: string;
declare const __BUILD_TAG__: string;

function xorDecode(encoded: string, key: string): string {
  const bytes = Uint8Array.from(atob(encoded), (c) => c.charCodeAt(0));
  const keyBytes = new TextEncoder().encode(key);
  const result = new Uint8Array(bytes.length);
  for (let i = 0; i < bytes.length; i++) {
    result[i] = bytes[i] ^ keyBytes[i % keyBytes.length];
  }
  return new TextDecoder().decode(result);
}

let env: Record<string, string>;

if (import.meta.env.DEV) {
  // In dev, Vite statically replaces these — tree-shaken out of prod builds
  env = {
    REACT_APP_API_BASE_URL: import.meta.env.REACT_APP_API_BASE_URL,
    REACT_APP_APP_NAME: import.meta.env.REACT_APP_APP_NAME,
    REACT_APP_GOOGLE_MAPS_API_KEY: import.meta.env
      .REACT_APP_GOOGLE_MAPS_API_KEY,
    REACT_APP_OUTLOOK_CLIENT_ID: import.meta.env.REACT_APP_OUTLOOK_CLIENT_ID,
    REACT_APP_POSTHOG_API_KEY: import.meta.env.REACT_APP_POSTHOG_API_KEY,
    REACT_APP_POSTHOG_HOST: import.meta.env.REACT_APP_POSTHOG_HOST,
    REACT_APP_SENTRY_DSN: import.meta.env.REACT_APP_SENTRY_DSN,
    REACT_APP_AGENT_API_URL: import.meta.env.REACT_APP_AGENT_API_URL,
    REACT_APP_DEMO_COMPANY_NAME_REPLACEMENTS: import.meta.env
      .REACT_APP_DEMO_COMPANY_NAME_REPLACEMENTS,
    REACT_APP_SUPPORT_EMAIL: import.meta.env.REACT_APP_SUPPORT_EMAIL,
  };
} else {
  // In prod, decode XOR-obfuscated config inlined in index.html
  const el = document.getElementById('__e');
  if (!el)
    throw new Error(
      'Production config element #__e is missing from index.html',
    );
  const encoded = el.textContent?.trim();
  if (!encoded) {
    throw new Error('Missing encoded frontend config payload (__e)');
  }
  env = JSON.parse(xorDecode(encoded, __BUILD_HASH__));
}

const config = {
  apiBaseUrl: env.REACT_APP_API_BASE_URL,
  appName: env.REACT_APP_APP_NAME || 'Gently',
  googleMapsApiKey: env.REACT_APP_GOOGLE_MAPS_API_KEY,
  isDev: import.meta.env.MODE === 'development',
  outlookClientId: env.REACT_APP_OUTLOOK_CLIENT_ID,
  posthogApiKey: env.REACT_APP_POSTHOG_API_KEY,
  posthogApiHost: env.REACT_APP_POSTHOG_HOST || 'https://e.gently-ai.com',
  sentryDsn: env.REACT_APP_SENTRY_DSN,
  agentApiUrl: env.REACT_APP_AGENT_API_URL,
  uiBuildHash: __BUILD_HASH__,
  uiBuildTime: __BUILD_TIME__,
  uiBuildTag: __BUILD_TAG__,
  demoCompanyNameReplacements: env.REACT_APP_DEMO_COMPANY_NAME_REPLACEMENTS,
  supportEmail: env.REACT_APP_SUPPORT_EMAIL || 'support@gently-ai.com',
};

export default config;
